<template>
	<JFlex class="s-w-full s-h-16 s-px-4 s-bg-white s-items-center s-shadow">
		<JFlex class="s-w-4/12 s-items-center">
			<JFlex
				class="s-w-9 s-h-9 s-flex-shrink-0 s-bg-gray-50 s-border s-border-gray-300 s-rounded-full s-items-center s-justify-center s-cursor-pointer s-mr-2"
				@click="$emit('back:click')"
			>
				<CIcon name="chevron-left" class="s-w-4 s-h-4 s-text-gray-400 s-fill-current" />
			</JFlex>
			<JHeadline class="s-text-xl">
				{{ headline }}
			</JHeadline>
			<slot name="left" />
		</JFlex>
		<JFlex class="s-w-4/12 s-items-center s-justify-center">
			<slot name="middle" />
		</JFlex>
		<JFlex class="s-w-4/12 s-justify-end s-items-center">
			<JSpinner :delay="0" v-if="isLoading" type="dots" />
			<JButton v-if="saveButton" @click="$emit('save:click')">{{ saveButton }}</JButton>
			<slot name="right" />
		</JFlex>
	</JFlex>
</template>

<script>
export default {
	props: {
		headline: {
			type: String
		},

		saveButton: {
			type: String
		},

		isLoading: {
			type: Boolean,
			default: () => false
		}
	}
}
</script>
